import { VehicleCondition } from 'types';

export const vehicleConditionMapping = new Map<VehicleCondition, string>([
  ['TO_REPAIR', 'Potentielles réparations à effectuer'],
  ['AVERAGE', "État correct, traces d'usure"],
  ['GOOD', 'Bon état'],
  ['VERY_GOOD', 'Très bon état'],
]);

export const VehicleConditionLabels: {
  label: string;
  decription: string;
}[] = [
  {
    label: 'Potentielles réparations à effectuer',
    decription: "Le véhicule peut présenter des traces d'usure et nécessiter quelques réparations.",
  },
  {
    label: "État correct, traces d'usure",
    decription: "Le véhicule présente des traces d'usure.",
  },
  {
    label: 'Bon état',
    decription: 'Le véhicule est dans un état standard par rapport aux véhicules de cet âge.',
  },
  {
    label: 'Très bon état',
    decription: 'Le véhicule est dans un état supérieur à la moyenne pour les véhicules de cet âge.',
  },
];
